import React, { useState } from "react";
import "./DogodkiPodstrani.css";

const images = [
  { src: "/Slike/Dogodki/Drazba2024/slika1.webp", text: "Slika 1: Razstava umetniših del", alt: "Razstava umetniških del" },
  { src: "/Slike/Dogodki/Drazba2024/slika2.webp", text: "Slika 2: Dobrodelni prispevki", alt: "Dobrodelni prispevki" },
  { src: "/Slike/Dogodki/Drazba2024/slika3.webp", text: "Slika 3: Glasbenica za harfo", alt: "Glasbenica za harfo" },
  { src: "/Slike/Dogodki/Drazba2024/slika4.webp", text: "Slika 4: Govor župana občine Komenda", alt: "Govor župana občine Komenda, " },
  { src: "/Slike/Dogodki/Drazba2024/slika5.webp", text: "Slika 5: Panorama dogodka", alt: "Mesto dražitelja" },
  { src: "/Slike/Dogodki/Drazba2024/slika6.webp", text: "Slika 6: Skupna zbrana donacija dogodka", alt: "Skupna zbrana donacija dogodka dražbe slik" },
];

const DrazbaSlik2024 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedText, setSelectedText] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleImageClick = (image, text, index) => {
    setSelectedImage(image);
    setSelectedText(text);
    setCurrentIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
    setSelectedText(null);
    setCurrentIndex(null);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    setSelectedImage(images[nextIndex].src);
    setSelectedText(images[nextIndex].text);
    setCurrentIndex(nextIndex);
  };

  const handlePrev = () => {
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setSelectedImage(images[prevIndex].src);
    setSelectedText(images[prevIndex].text);
    setCurrentIndex(prevIndex);
  };

  return (
    <div className="dogodkipodstranigallerycontainer">
      <h1 className="dogodkipodstranigallerytitle">Dražba umetniških del 23.09.2024 Grad Komenda </h1>
      <h3>( Galerija Slik )</h3>
      <div className="dogodkipodstranigallery">
      {images.map((image, index) => (
        <div className="dogodkipodstranigalleryitem" key={index}>
          <img
             src={image.src}
             alt={image.alt}
             className="dogodkipodstranigalleryimage"
             loading={index < 4 ? "eager" : "lazy"} 
             onClick={() => handleImageClick(image.src, image.text, index)}
           />
         <p className="dogodkipodstraniimagetext">{image.text}</p>
       </div>
      ))}
      </div>

      <br></br>
       <p style={{ color: "#17458f" }}>( Število Fotografij : {images.length} )</p>

      {selectedImage && (
        <div className="dogodkimodal" onClick={handleCloseModal}>
          <div className="dogodkimodalcontent" onClick={(e) => e.stopPropagation()}>
            <button className="dogodkiarrow-left" onClick={handlePrev}>
              &#8592;
            </button>
            <img
              src={selectedImage}
              alt="Full-size event"
              className="dogodkimodalimage"
            />
            <p className="dogodkimodaltext">{selectedText}</p>
            <button className="dogodkiclosebutton" onClick={handleCloseModal}>
              X
            </button>
            <button className="dogodkiarrow-right" onClick={handleNext}>
              &#8594;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DrazbaSlik2024;